import { KeycloakConfig } from "keycloak-js";
import "zone.js/dist/zone-error";

let keycloakConfig: KeycloakConfig = {
  url: "https://auth.ecotx.dev",
  realm: "eco-realm",
  clientId: "ecotx-backoffice",
};

let powerBiConfig = {
  reportBaseURL: "https://app.powerbi.com/reportEmbed",
  qnaBaseURL: "https://app.powerbi.com/qnaEmbed",
  tileBaseURL: "https://app.powerbi.com/embed",
  groupID: "3aca5f3d-d7af-4311-a3c7-89f8716479bc",
  reportID: "619c668f-9be0-4589-ae6d-3f456847eeb2",
};

export const environment = {
  production: false,
  appVersion: "ecotx-backoffice.v1",
  USERDATA_KEY: "authf649fc9a5f55",
  isMockEnabled: false,
  apiUrl: "https://platform-service.ecotx.dev/api",
  apiGraphqlUrl: "https://platform-service.ecotx.dev/graphql",
  userProfileApiUrl: "https://user.ecotx.dev",
  mapServicesUrl: "https://map-services.ecotx.dev",
  datlazChartServiceUrl: "https://datlaz-chart-service.ecotx.dev",
  geoProcessingUrl: "https://geoprocessing.ecotx.dev",
  paymentsApiUrl: "https://payments.ecotx.dev",
  mediaUrl: "/mediaService",
  keycloak: keycloakConfig,
  powerBi: powerBiConfig,
  ecotxPlatformUrl: "https://platform.ecotx.dev",
  eMapUrl: "https://map.ecotx.dev",
  mediaServiceUrl: "https://media-service.ecotx.dev",
  mediaFileUrl: "https://geoserver.ecotx.dev/storage/media",
  ecotxNotificationsWSS: 'wss://notifications.ecotx.dev/websocket',
  elasticSearchServiceApiUrl: 'https://layer-service-data.ecotx.dev',
  assetsReportUrl: 'https://assets-report.ecotx.dev',
  sacoServiceUrl: 'https://saco.datlaz.com',
  botsServiceUrl: 'https://dashboards.datlaz.com',
  // painéis próprios (datlaz-paineis): o Monitoramento da Plataforma abre daqui
  paineisUrl: 'https://paineis.datlaz.com',
  marginServiceUrl: 'https://margin-service.ecotx.dev',
  features: {
    suporte: true,
    comercial: true,
  },
};